import { render, staticRenderFns } from "./UsuariosTable.vue?vue&type=template&id=0e63f2aa"
import script from "./UsuariosTable.vue?vue&type=script&lang=ts"
export * from "./UsuariosTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports